<template>
    <el-dialog title="设置年框" :visible.sync="visible" width="800px" center custom-class="default-table">
        <div>
            <div>
                批量设置以下订单为：
                <el-radio v-model="radio" label="Y">年框</el-radio>
                <el-radio v-model="radio" label="N">非年框</el-radio>
            </div>
            <el-table :data="orders" style="width: 100%;margin-top: 20px;">
                <el-table-column prop="order_no" label="订单编号" width="180"/>
                <el-table-column prop="payment_account" label="含税收入" header-align="center" align="right"/>
                <el-table-column prop="sale_name" label="销售"/>
                <el-table-column prop="year_frame_alias" label="年框"/>
                <el-table-column prop="created_timestamp_alias" label="下单时间" width="180"/>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false" size="mini">取 消</el-button>
          <el-button type="primary" @click="handelSure" size="mini">确 定</el-button>
        </span>
    </el-dialog>

</template>

<script>
import {setYearFrame} from "@/api/adOrder";

export default {
    name: "DialogYearFrame",
    props: {
        show: {
            type: Boolean,
            default() {
                return false
            }
        },
        orders: {
            type: Array,
            required: true
        }
    },
    watch: {
        show: function (v) {
            if (v) {
                this.visible = v
            }
        },
        visible: function (v) {
            if (!v) {
                this.$emit('update:show', false)
            }
        }
    },
    data() {
        return {
            visible: this.show,
            radio: 'N'
        }
    },
    methods: {
        async handelSure() {
            const order_nos = this.orders.map(_ => {
                return _.order_no
            })
            const that = this;
            const response = await setYearFrame({year_frame: this.radio, order_nos});
            if (!response.success) {
                this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
                return;
            }
            this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
            this.visible = false
            this.$emit('success')
        },
    }
}
</script>

<style scoped>

</style>
